"use strict";
const ajaxHelper = (function () {
    const cache = new Map();

    const getAsync = async (url, useCache = false) => {
        if (!useCache || !cache.has(url)) {
            cache.set(url, _getAsync(url));
        }
        return await cache.get(url);
    };

    const _getAsync = async (url) => {
        const response = await fetch(url, {
            credentials: 'include',
            headers: {
                "Cache-Control": 'no-cache'
            }
        });
        if (response.ok) {
            const contentType = response.headers.get("content-type");
            if (contentType && contentType.indexOf("application/json") !== -1) {
                return await response.json();
            }
            return await response.text();
        }
    };

    const postAsync = async (url, data) => {
        return await _post(url, data);
    };

    const postWithJsonResponseAsync = async (url, data) => {
        const response = await _post(url, data);
        if (response.ok) {
            return await response.json();
        }
    };

    const postWithResponseAsync = async (url, data) => {
        const response = await _post(url, data);
        if (response.ok) {
            return await response.text();
        }
    };

    const _post = async (url, data) => {
        return await fetch(url, {
            method: 'POST',
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        });
    };

    const clearCache = () => {
        cache.clear();
    };

    return {
        getAsync,
        postAsync,
        postWithJsonResponseAsync,
        postWithResponseAsync,
        clearCache
    };
})();

export default ajaxHelper;
